/**
 * Kids mode's start (docs/refactor/48): "O que vamos construir hoje?", three big ideas that send the child's request
 * through the prompt box — where the teacher's prompt (catalog tutor.kids) goes around it — and the rooms below, where
 * they watch their AI at work.
 */

import { Gamepad2, Globe, Lightbulb } from 'lucide-react'
import type { ReactNode } from 'react'
import { useI18n } from '../lib/i18n'
import { sendCommand } from '../lib/dockPlacement'
import Floor from './Floor'

const IDEAS: Array<{ id: 'game' | 'site' | 'learn'; icon: ReactNode }> = [
  { id: 'game', icon: <Gamepad2 size={28} aria-hidden /> },
  { id: 'site', icon: <Globe size={28} aria-hidden /> },
  { id: 'learn', icon: <Lightbulb size={28} aria-hidden /> },
]

export default function KidsHome() {
  const { t } = useI18n()
  return (
    <div className="stack kids-home">
      <header className="kids-home__hello">
        <h1 className="kids-home__title">{t('kids.title')}</h1>
        <p className="kids-home__lead">{t('kids.lead')}</p>
      </header>
      <div className="kids-home__ideas">
        {IDEAS.map((idea) => (
          <button
            key={idea.id}
            type="button"
            className="kids-home__idea"
            onClick={() => sendCommand(t(`kids.idea.${idea.id}.request`), t(`kids.idea.${idea.id}`))}
          >
            {idea.icon}
            <span className="kids-home__idea-title">{t(`kids.idea.${idea.id}`)}</span>
            <span className="kids-home__idea-hint">{t(`kids.idea.${idea.id}.hint`)}</span>
          </button>
        ))}
      </div>
      <p className="small muted">{t('kids.orType')}</p>
      <Floor />
    </div>
  )
}
